import type { Reading } from '@/types/reading'

/** Every theme used by these readings, once, alphabetically. */
export function themesIn(readings: Reading[]): string[] {
  return [...new Set(readings.flatMap((r) => r.themes))].sort()
}

/**
 * Readings carrying any of the selected themes (all of them when none is selected) whose
 * title or a theme contains the query, ignoring case.
 */
export function matchingReadings(readings: Reading[], selected: string[], query: string): Reading[] {
  const q = query.trim().toLowerCase()
  return readings.filter(
    (r) =>
      (selected.length === 0 || r.themes.some((t) => selected.includes(t))) &&
      (q === '' || r.title.toLowerCase().includes(q) || r.themes.some((t) => t.includes(q))),
  )
}
